PluginChromeView = require 'app/scripts/views/plugin/plugin-chrome-view'

module.exports = class PluginBoardBarView extends PluginChromeView
  initialize: ({ @content }) ->
    @retain(@content)

  className: 'plugin-board-bar'
